import { TOGGLE_THEME } from "../actions/types";

const initial_state = {
  themeType:
    JSON.parse(localStorage.getItem("theme_type")) == null
      ? "light"
      : JSON.parse(localStorage.getItem("theme_type")),
};

const themeReducer = (state = initial_state, action) => {
  let { type, payload } = action;
  switch (type) {
    case TOGGLE_THEME:
      localStorage.setItem("theme_type", JSON.stringify(payload));
      document.body.classList.remove("light");
      document.body.classList.remove("dark");
      document.body.classList.add(payload);
      return {
        ...state,
        themeType: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default themeReducer;
